<template>
  <div class="line-item-v2">
    <div class="d-flex mb-3 align-center justify-space-between flex-wrap">
      <div class="d-flex align-center">
        <v-autocomplete
          v-if="relatedType != 7"
          hide-details
          v-model.trim="module_type"
          :items="modulesType"
          clearable
          v-on:click:clear="module_type = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select item type"
          item-color="cyan"
          class="mr-2 custom-boder-color"
          color="cyan"
          solo
          v-on:change="open_dialog($event)"
          item-value="value"
          item-text="text"
        >
        </v-autocomplete>
        <v-btn-toggle color="cyan" group class="rounded-lg">
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="product"
            v-on:click="open_dialog('product')"
            v-if="relatedType != 7 && false"
          >
            Product
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="service"
            v-on:click="open_dialog('service')"
            v-if="relatedType != 7 && false"
          >
            Service
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="equipment"
            v-if="relatedType == 7"
            v-on:click="open_dialog('equipment')"
          >
            Equipment
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="tools"
            v-on:click="open_dialog('tools')"
            v-if="relatedType != 7 && false"
          >
            Equipment/Tools
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="header"
            v-on:click="add_header()"
            style="height: 32px !important"
          >
            Header
          </v-btn>
          <v-btn
            color="cyan"
            class="custom-bold-button"
            value="other"
            v-on:click="add_other()"
            style="height: 32px !important"
            v-if="relatedType != 7"
          >
            <v-icon small class="mr-1">mdi-plus</v-icon>
            Other
          </v-btn>
        </v-btn-toggle>
      </div>
      <div class="d-flex align-center">
        <v-checkbox
          v-if="!isEnquiry && !isQuotation && !isPreventive && !isProject"
          class="my-0 py-0 mr-3"
          v-model="show_price"
          v-on:change="emit_values()"
          color="cyan"
          hide-details
          label="Show Price To Engineer"
        />
        <div class="d-flex align-center ml-2 pl-3 custom-border-left">
          <label
            for="discount-level"
            class="mb-0 font-weight-600 font-size-13 color-custom-blue mr-2 text-nowrap"
            >Discount Level</label
          >
          <v-autocomplete
            :menu-props="{ offsetY: true }"
            :disabled="relatedDetail && relatedDetail.id > 0"
            hide-details
            v-model.trim="discount_level"
            :items="transactions"
            style="max-width: 180px !important"
            dense
            flat
            filled
            placeholder="Discount Level"
            item-color="cyan"
            class="custom-boder-color"
            color="cyan"
            solo
            v-on:change="calculate_total()"
            item-value="value"
            item-text="text"
          >
          </v-autocomplete>
        </div>
      </div>
    </div>

    <v-card
      flat
      outlined
      class="rounded-lg border-slate bg-white overflow-hidden mb-4 shadow-0"
    >
      <div class="d-flex grey lighten-4 border-bottom align-center px-3 py-2">
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-center d-flex align-center justify-center"
          style="width: 5%"
        >
          #
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-left px-2 d-flex align-center"
          :style="get_col_style('product')"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-package-variant-closed</v-icon
          >
          <template v-if="relatedType == 7">Equipment</template>
          <template v-else>Product / Service / Equipment</template>
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 10%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-tag-outline</v-icon
          >
          Rate
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 10%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-ruler-square</v-icon
          >
          UOM
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 10%"
        >
          <v-icon small color="cyan darken-2" class="mr-1">mdi-numeric</v-icon>
          Quantity
        </div>
        <div
          v-if="discount_level == 'line_item'"
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 15%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-percent-outline</v-icon
          >
          Discount
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 10%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-cash-multiple</v-icon
          >
          Total
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-center"
          style="width: 5%"
        ></div>
      </div>
      <Draggable
        tag="ul"
        v-model="selected_line_items"
        class="line-item-drag-group mb-0 pa-0"
        draggable=".line-item-drag"
        handle=".line-item-drag-icon"
        ghost-class="line-item-ghost"
        :key="`line-item-img-${dialog_key}`"
        animation="200"
        group="line-item-drag"
        v-on:start="drag = true"
        v-on:end="drag = false"
        v-on:change="emit_values()"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            v-for="(row, index) in selected_line_items"
            class="line-item-drag border-bottom border-slate-100 hover:bg-slate-50 transition-fast pa-0"
            :class="{
              'alternate-line-item-row bg-slate-50':
                selected_line_items[index + 1]?.is_child,
            }"
            :key="`line-item-drag-${index}`"
          >
            <div
              :id="`line-item-drag-${index}`"
              class="d-flex align-center py-2 px-3"
              :class="{ 'item-is-child pl-4': row.is_child }"
            >
              <div class="font-weight-600 text-center" style="width: 5%">
                <v-icon
                  v-if="!row.is_child"
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.is_child"
                class="font-weight-600 text-center"
                style="width: 5%"
              >
                <v-icon
                  class="line-item-drag-icon cursor-move text-slate-400 hover-cyan"
                  >mdi-drag</v-icon
                >
              </div>
              <div
                v-if="row.type == 'header'"
                class="text-left px-2"
                style="width: 90%"
              >
                <v-text-field
                  v-model="row.product"
                  class="line-item-header-text px-0"
                  placeholder="Header Title"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  v-on:change="changeName(index, row.product)"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-chip
                      color="cyan white--text"
                      label
                      small
                      class="lip-type text-uppercase font-weight-600 header"
                    >
                      Header
                    </v-chip>
                  </template>
                </v-text-field>
              </div>
              <div
                v-else
                class="text-left px-2"
                :style="get_col_style('product', row.is_child)"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    size="32"
                    v-if="row.product_type != 'other'"
                    class="rounded-lg border"
                  >
                    <img
                      v-if="row?.image?.url"
                      :src="row?.image?.url"
                      :alt="row?.image?.name"
                    />
                    <img v-else :src="$defaultImage" />
                  </v-avatar>
                  <div style="width: 100%" class="ml-2">
                    <v-expansion-panels class="cepfli flat">
                      <v-expansion-panel class="bg-transparent">
                        <v-expansion-panel-header class="pa-0 min-height-unset">
                          <v-text-field
                            v-model="row.product"
                            class="line-item-header-text px-0"
                            placeholder="Product/Service/Equipment & Tools"
                            dense
                            filled
                            solo
                            v-on:change="changeName(index, row.product)"
                            flat
                            hide-details
                            color="cyan"
                          >
                            <template v-slot:append>
                              <v-chip
                                color="cyan white--text"
                                label
                                small
                                class="lip-type text-uppercase font-weight-600"
                                :class="{
                                  product: row.product_type == 'goods',
                                  service: row.product_type == 'service',
                                  parts: row.product_type == 'parts',
                                  equipment: row.product_type == 'equipment',
                                  tools: row.product_type == 'tools',
                                  other: row.product_type == 'other',
                                }"
                              >
                                <template v-if="row.type == 'tools'">
                                  Tools</template
                                >
                                <template v-else-if="row.type == 'equipment'">
                                  Equipment</template
                                >
                                <template v-else> {{ row.type }}</template>
                              </v-chip>

                              <v-chip
                                class="lip-type ml-2 bg-slate-100"
                                color="cyan darken-2"
                                label
                                small
                              >
                                <v-icon
                                  :disabled="contractYears < 1"
                                  small
                                  @click.stop="openYearCostDialog(row)"
                                >
                                  mdi-cog
                                </v-icon>
                              </v-chip>
                            </template>
                          </v-text-field>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content class="px-0 pt-2">
                          <v-textarea
                            class="px-0 mb-0"
                            v-model="row.description"
                            placeholder="Description"
                            dense
                            filled
                            solo
                            flat
                            rows="2"
                            auto-grow
                            hide-details
                            color="cyan"
                            v-on:change="changeDes(index, row.description)"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="d-flex align-center flex-wrap ml-0 mt-1">
                      <v-chip
                        v-if="row.barcode"
                        label
                        color="cyan darken-3"
                        outlined
                        x-small
                        class="font-weight-700 mr-2"
                        v-on:click="routeToDetail(row)"
                        >{{ row.barcode }}</v-chip
                      >
                      <v-checkbox
                        v-if="row.type == 'product'"
                        color="cyan"
                        label="Add as equipment"
                        dense
                        class="pt-0 mt-0 ml-2"
                        v-model="row.is_equipment"
                        hide-details
                        :false-value="0"
                        :true-value="1"
                        v-on:change="changeEquipment(index, row.is_equipment)"
                      >
                      </v-checkbox>
                      <template
                        v-if="
                          row.product_type != 'goods' &&
                          row &&
                          row.has_warranty &&
                          row.has_warranty == 1 &&
                          row.warranty_status > 0
                        "
                      >
                        <v-chip
                          :color="getWarrantyStatusColor(row.warranty_status)"
                          x-small
                          text-color="white"
                          class="font-weight-600 mr-2"
                        >
                          Warranty
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_barcode &&
                          row.preventive_id > 0 &&
                          showModules.preventive_maintanance
                        "
                      >
                        <v-chip
                          :color="row?.is_consumed ? 'red' : 'cyan darken-2'"
                          class="mr-2 font-weight-600"
                          x-small
                          outlined
                          v-on:click.prevent.stop="
                            routeToDetailLink(
                              row.preventive_id,
                              'admin.preventive-maintanance.detail'
                            )
                          "
                        >
                          {{ row.preventive_barcode }}
                        </v-chip>
                      </template>
                      <template
                        v-if="
                          row.product_type == 'equipment' &&
                          row &&
                          row.preventive_id &&
                          row.preventive_barcode &&
                          row.preventive_id > 0 &&
                          showModules.location
                        "
                      >
                        <v-chip
                          :color="row?.is_consumed ? 'red' : 'cyan darken-2'"
                          class="mr-2 font-weight-600"
                          x-small
                          outlined
                          v-on:click.prevent.stop="
                            routeToDetailLink(
                              row.preventive_id,
                              'admin.preventive-maintanance.detail'
                            )
                          "
                        >
                          {{ row.location }}
                        </v-chip>
                      </template>
                      <v-spacer></v-spacer>

                      <div
                        class="mt-0"
                        v-if="
                          row.product_type == 'equipment' &&
                          row.preventive_id &&
                          row.preventive_id > 0 &&
                          row.is_consumed > 0 &&
                          showModules.preventive_maintanance
                        "
                      >
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="cyan"
                              v-on:click="openSchedule(row.preventive_id)"
                              >mdi-information-outline</v-icon
                            >
                          </template>
                          <span>PM Schedules</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-2"
                style="width: 10%"
              >
                <PriceField
                  class="line-item-header-text px-0"
                  placeholder="Selling/Unit Cost"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="text"
                  inputmode="decimal"
                  maxlength="9"
                  v-model="row.rate"
                  v-on:keyup="calculate_total()"
                  color="cyan"
                />
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-2"
                style="width: 10%"
              >
                <v-autocomplete
                  :menu-props="{ offsetY: true }"
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  :items="unitList"
                  placeholder="UOM"
                  solo
                  flat
                  hide-details
                  item-text="text"
                  item-value="value"
                  class="pr-0 width-100"
                  v-model.trim="row.uom"
                  v-on:change="emit_values()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No UOM Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-2"
                style="width: 10%"
              >
                <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Quantity"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  max="5000"
                  :maxlength="row.product_type == 'service' ? 4 : null"
                  :readonly="row.type == 'equipment' || row.type == 'tools'"
                  v-model="row.quantity"
                  :prepend="row.uom"
                  v-on:keyup="checkAvailableQuantity(row), calculate_total()"
                  v-on:keypress="
                    isNumber($event);
                    row.product_type == 'service' &&
                      limitMaxLength($event, row.quantity, 4);
                  "
                  color="cyan"
                />
              </div>
              <div
                v-if="discount_level == 'line_item' && !(row.type == 'header')"
                class="text-center px-2"
                style="width: 15%"
              >
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    type="number"
                    v-model="row.discount_value"
                    v-on:keyup="calculate_total()"
                    v-on:keypress="
                      limitDecimal($event, row.discount_value),
                        validateDiscountKeypress($event, row)
                    "
                    color="cyan"
                    style="width: 60%"
                    :disabled="row.quantity == 0"
                  />
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="row.discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType2(row)"
                    color="cyan"
                    style="width: 40%"
                  />
                </div>
              </div>
              <div
                v-if="!(row.type == 'header')"
                class="text-center px-2"
                style="width: 10%"
              >
                <v-text-field
                  class="line-item-header-text px-0 font-weight-600"
                  placeholder="Total"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  v-model="row.total"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="limitDecimal($event, row.total)"
                  color="cyan"
                />
              </div>
              <div
                class="font-weight-600 d-flex align-center justify-center"
                style="width: 5%"
              >
                <template v-if="!row.is_child && relatedType != 7">
                  <v-menu v-if="row.has_child" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        small
                        color="cyan darken-2"
                      >
                        <v-icon small
                          >mdi-dots-horizontal-circle-outline</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="py-0 rounded-lg" min-width="160px">
                      <v-list-item
                        v-if="!row.is_child"
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'equipment')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Equipment</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="!row.is_child && relatedType != 7"
                        link
                        class="border-bottom"
                        v-on:click="add_child(index, 'product')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Product</v-list-item-title
                        >
                      </v-list-item>

                      <v-list-item
                        v-if="!row.is_child && relatedType != 7"
                        link
                        v-on:click="add_child(index, 'service')"
                      >
                        <v-list-item-title class="font-weight-600 font-size-13">
                          Add Service</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  v-on:click="remove_row(index, row)"
                  icon
                  small
                  color="red lighten-1"
                >
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </transition-group>
      </Draggable>
      <template v-if="!selected_line_items.length">
        <div class="p-4 text-center">
          <p
            class="m-0 p-3 font-size-14 font-weight-500 text-slate-600 bg-slate-50 border-slate rounded-lg d-inline-flex align-center justify-center"
          >
            <v-icon color="cyan darken-2" small class="mr-2"
              >mdi-alert-circle-outline</v-icon
            >
            No line items added yet. Use the action bar above to add items.
          </p>
        </div>
      </template>
    </v-card>
    <div v-if="false" class="d-flex align-center">
      <v-autocomplete
        v-if="relatedType != 7"
        hide-details
        v-model.trim="module_type"
        :items="modulesType"
        clearable
        v-on:click:clear="module_type = null"
        style="max-width: 220px !important"
        dense
        flat
        filled
        placeholder="Select item type"
        item-color="cyan"
        class="mr-2 custom-boder-color"
        color="cyan"
        solo
        v-on:change="open_dialog($event)"
        item-value="value"
        item-text="text"
      >
      </v-autocomplete>
      <v-btn-toggle color="cyan" group>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="product"
          v-on:click="open_dialog('product')"
          v-if="relatedType != 7 && false"
        >
          Product
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="service"
          v-on:click="open_dialog('service')"
          v-if="relatedType != 7 && false"
        >
          Service
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="equipment"
          v-if="relatedType == 7"
          v-on:click="open_dialog('equipment')"
        >
          Equipment
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="tools"
          v-on:click="open_dialog('tools')"
          v-if="relatedType != 7 && false"
        >
          Equipment/Tools
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="header"
          v-on:click="add_header()"
          style="height: 32px !important"
        >
          Header
        </v-btn>
        <v-btn
          color="cyan"
          class="custom-bold-button"
          value="other"
          v-on:click="add_other()"
          style="height: 32px !important"
          v-if="relatedType != 7"
        >
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Other
        </v-btn>
      </v-btn-toggle>
    </div>

    <!-- Summary & Totals Box -->
    <div class="d-flex justify-end mb-4">
      <v-card
        flat
        outlined
        class="rounded-lg bg-slate-50 pa-4 border-slate w-100 shadow-0"
        style="max-width: 550px"
      >
        <div
          class="d-flex align-center justify-space-between pb-2 mb-3 border-bottom"
        >
          <div class="d-flex align-center">
            <v-icon small color="cyan darken-2" class="mr-2"
              >mdi-calculator-variant-outline</v-icon
            >
            <span class="font-size-15 font-weight-700 color-custom-blue"
              >Summary & Totals</span
            >
          </div>
        </div>

        <table width="100%" style="table-layout: fixed">
          <tbody>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Sub Total
              </td>
              <td width="30%" valign="middle" align="center" class="py-1"></td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(subtotal) }}
              </td>
            </tr>
            <tr v-if="discount_level == 'transaction'">
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Discount
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <div class="d-flex">
                  <v-text-field
                    hide-details
                    class="line-item-header-text px-0"
                    placeholder="Discount"
                    dense
                    filled
                    solo
                    flat
                    v-model="discount_value"
                    v-on:keyup="calculate_total(), checkData()"
                    v-on:keypress="
                      limitDecimal($event, discount_value),
                        checkData(),
                        manageDiscount($event)
                    "
                    v-on:paste="validateTransactionDiscountPaste($event)"
                    v-on:change="checkData()"
                    color="cyan"
                  />

                  <v-select
                    :menu-props="{ offsetY: true }"
                    :items="discount_type_list"
                    v-model="discount_type"
                    hide-details
                    item-text="type"
                    item-value="value"
                    item-color="cyan"
                    class="line-item-header-text discount-type px-0 ml-1"
                    placeholder="Type"
                    dense
                    filled
                    solo
                    flat
                    v-on:change="calculate_total(), changeDiscountType()"
                    color="cyan"
                  />
                </div>
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(discount) }}
              </td>
            </tr>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Tax [GST {{ gst_value }}%]
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-checkbox
                  v-on:change="calculate_total()"
                  v-model="tax_active"
                  class="my-0 py-0 px-0 mx-0"
                  color="cyan"
                  hide-details
                  :label="`Apply Tax`"
                />
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(gst) }}
              </td>
            </tr>
            <tr>
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 text-slate-700 py-1"
              >
                Adjustment
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-text-field
                  hide-details
                  class="line-item-header-text px-0 line-item-adjustment"
                  placeholder="Adjustment"
                  dense
                  filled
                  solo
                  flat
                  v-model="adjustment"
                  v-on:keyup="calculate_total()"
                  v-on:keypress="
                    limitDecimal($event, adjustment),
                      limitMaxLength($event, adjustment, 10)
                  "
                  :maxlength="10"
                  color="cyan"
                >
                  <template v-slot:append>
                    <v-btn
                      x-small
                      depressed
                      color="cyan darken-2 white--text"
                      class="px-2 rounded-sm"
                      v-on:click="auto_adjust()"
                      >Auto</v-btn
                    >
                  </template>
                </v-text-field>
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              >
                {{ formatMoney(adjustment) }}
              </td>
            </tr>
            <tr v-if="show_collected">
              <td
                width="40%"
                valign="middle"
                align="left"
                class="font-weight-600 font-size-14 red--text text--darken-2 py-1"
              >
                Amount to be collected
              </td>
              <td width="30%" valign="middle" align="center" class="py-1">
                <v-text-field
                  class="line-item-header-text px-0"
                  placeholder="Collected Amount"
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  v-model="collected_amount"
                  v-on:keypress="limitDecimal($event, collected_amount)"
                  color="cyan"
                />
              </td>
              <td
                width="30%"
                valign="middle"
                align="right"
                class="font-weight-700 font-size-14 color-custom-blue py-1"
              ></td>
            </tr>
          </tbody>
        </table>

        <!-- Grand Total Highlight Banner -->
        <div
          class="d-flex align-center justify-space-between pa-3 rounded-lg bg-cyan-50 border-top mt-3"
        >
          <span class="font-size-15 font-weight-700 text-slate-900"
            >Grand Total</span
          >
          <span class="font-size-20 font-weight-800 color-custom-blue">{{
            formatMoney(total)
          }}</span>
        </div>
      </v-card>
    </div>

    <LineItemDialog
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :isType="relatedType"
      :product-dialog="product_dialog"
      :module-type="relatedType"
      v-on:update-values="update_line_item($event)"
      v-on:close="closeProductDialog"
    />

    <Dialog :commonDialog="yearCostDialog" style="width: 600px">
      <template v-slot:title>
        <div class="text-h6 font-weight-700 color-custom-blue">
          {{ barCode ? barCode + " - " : ""
          }}{{ selectedLineItem?.product }} ({{ filledCostCount }}/{{
            contractYearsArray.length
          }})
        </div>
      </template>
      <template v-slot:body>
        <v-form ref="form" v-model="formValid">
          <v-row
            v-for="(entry, key) in selectedLineItem?.yearly_costs"
            :key="key"
            align="center"
          >
            <v-col cols="12" sm="3">
              <div>
                <div v-if="key === 0">
                  <label
                    class="mb-2 font-size-14 font-weight-600 color-custom-blue"
                    >Year</label
                  >
                </div>
                <strong>
                  <label
                    :for="`year-cost-${key}`"
                    class="font-size-13 text-slate-700"
                  >
                    {{ getOrdinalSuffix(entry.year) }} Year
                  </label>
                </strong>
              </div>
            </v-col>

            <v-col cols="12" sm="9">
              <div v-if="key === 0">
                <label
                  for="cost-field"
                  class="font-size-14 font-weight-600 color-custom-blue"
                  >Cost</label
                >
              </div>

              <v-text-field
                v-model="entry.cost"
                :id="`year-cost-${key}`"
                type="number"
                dense
                color="cyan"
                filled
                solo
                flat
                hide-details
                placeholder="Cost"
                prefix="$"
              />
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          v-on:click="saveCost()"
        >
          Save
        </v-btn>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="closeDialog"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
    <ManageWarranty
      :dialog-status="addWarrantyDialog"
      v-on:close:dialog="addWarrantyDialog = false"
      v-on:warrnty:data="warrantyData($event)"
    ></ManageWarranty>
    <AddressSelect
      line-item
      :key="`address-select-dialog-${dialog_key}`"
      :dialog="property_dialog"
      v-on:close="property_dialog = false"
      type="property"
      label="Service Location"
      v-on:update="update_child_property($event)"
    />
    <div class="d-none">
      <v-file-input
        :ref="`line-item-image`"
        v-on:change="updateProfileImage"
        multiple
        accept="image/png, image/jpeg, image/jpg"
      ></v-file-input>
    </div>
    <PMSchedule
      v-if="scheduleDialog"
      :parent-id="pmId"
      :dialogStatus="scheduleDialog"
      v-on:close:dialog="scheduleDialog = false"
    >
    </PMSchedule>
    <SerialNumber
      v-if="seleceDialog"
      :transaction-detail="transactionDetail"
      :parent-index="numberIndex"
      :dialogStatus="seleceDialog"
      :serial-number="numbersArr"
      v-on:close:dialog="seleceDialog = false"
      v-on:update:item="savedata"
    >
    </SerialNumber>

    <ManageUnit
      :u-dialog="manageUnitDialog"
      :unit="unitList"
      v-on:close-dialog="manageUnitDialog = false"
      v-on:get-product-unit="getOptions"
    ></ManageUnit>
  </div>
</template>

<script>
import { QUERY, GET } from "@/core/services/store/request.module";
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import AddressSelect from "@/view/components/LineItemAddressSelect.vue";
import LineItemDialog from "@/view/components/LineItemDialog.vue";
import AppConfiguration from "@/core/config/app.config.js";
import PMSchedule from "@/view/pages/preventive-maintanance/PMScheduleView.vue";
import SerialNumber from "@/view/pages/partials/Serial-Number-Select.vue";
import {
  SET_VISIT_LINE_ITEM,
  SET_VISIT_CALCULATION,
} from "@/core/services/store/visit.module";
import {
  UPDATE_SCHEDULE_LIST,
  UPDATE_SCHEDULE_LIST_QUOTE,
  UPDATE_SCHEDULE_STATE,
} from "@/core/services/store/invoice.module";
import { toBtxNumber, toBtxFixed } from "@/core/services/common.service";
import CommonMixin from "@/core/plugins/common-mixin.js";
import { find } from "lodash";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { v4 as uuidv4 } from "uuid";
import ManageWarranty from "@/view/pages/partials/Create-Warranty-Intenal.vue";
import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog";
import ManageUnit from "@/view/pages/partials/Manage-Part-Unit.vue";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  name: "line-item-v1",
  mixins: [CommonMixin],
  data() {
    return {
      defaultYearlyCosts: {},
      manageUnitDialog: false,
      unitList: [],
      selectedLineItem: null,
      yearCostDialog: false,
      drag: false,
      pmData: [],
      module_type: null,
      transactionDetail: {},
      numbersArr: [],
      seleceDialog: false,
      numberIndex: 0,
      modulesType: [
        {
          value: "goods",
          text: "Product",
          show: false,
        },
        {
          value: "parts",
          text: "Part",
          show: true,
        },
        {
          value: "service",
          text: "Service",
          show: false,
        },
        {
          value: "equipment",
          text: "Equipment",
          show: false,
        },
      ],
      dialog_key: Number(new Date()),
      product_type: null,
      product_dialog: false,
      child_index: null,
      addWarrantyDialog: false,
      append_child: false,
      warrantyObject: {},
      property_dialog: false,
      tax_active: false,
      do_update: 0,
      show_price: false,
      transactions: [
        {
          text: "Transaction",
          value: "transaction",
        },
        {
          text: "Line Item",
          value: "line_item",
        },
      ],
      discount_level: "transaction",
      imageRules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Image size should be less than 2 MB!",
      ],
      imageSrc: [],
      selected_line_items: [],
      currentEntityDb: {},
      subtotal: 0,
      collected_amount: 0,
      discount: 0,
      scheduleDialog: false,
      pmId: 0,
      gst: 0,
      gst_amount: 0,
      gst_value: 9,
      adjustment: 0,
      total_non_text_amount: 0,
      total: 0,
      customIndex: 0,
      discount_value: null,
      discount_type: 1,
      /*   localEntity: [], */
      discount_type_list: [
        { type: "%", value: 2 },
        { type: "$", value: 1 },
      ],
      show_collected: false,
    };
  },
  props: {
    unit: {
      type: Array,
      default() {
        return [];
      },
    },
    relatedDetail: {
      type: Object,
      default: null,
    },

    dbLineItems: {
      type: Array,
      default() {
        return [];
      },
    },
    dbEquipments: {
      type: Array,
      default() {
        return [];
      },
    },
    entityId: {
      type: Number,
      default: 0,
    },
    isJob: {
      type: Boolean,
      default: false,
    },
    isCollected: {
      type: Boolean,
      default: false,
    },
    relatedType: {
      type: Number,
      default: 3,
    },
    isEnquiry: {
      type: Boolean,
      default: false,
    },
    isQuotation: {
      type: Boolean,
      default: false,
    },
    isPreventive: {
      type: Boolean,
      default: false,
    },
    itemSet: {
      type: Boolean,
      default: false,
    },

    isProject: {
      type: Boolean,
      default: false,
    },

    contractYears: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    subtotal(newVal, oldVal) {
      if (
        this.discount_level === "transaction" &&
        toBtxNumber(newVal) !== toBtxNumber(oldVal)
      ) {
        this.discount_value = 0;
      }
    },
    selected_line_items: {
      deep: true,
      handler(items) {
        // 🛑 clear previous run
        clearTimeout(this.qtyWatcherTimer);

        // ⏳ wait till value settles
        this.qtyWatcherTimer = setTimeout(() => {
          items.forEach((row) => {
            const qty = toBtxNumber(row.quantity);
            const rate = toBtxNumber(row.rate);
            const lineTotal = qty * rate;

            // ✅ only REAL zero case
            if (qty === 0) {
              row.discount_value = null;
              row.total = 0;
              return;
            }

            // existing logic (safe)
            if (row.discount_type == 1 && row.discount_value > lineTotal) {
              row.discount_value = 0;
            }

            if (row.discount_type == 2 && row.discount_value > 100) {
              row.discount_value = 100;
            }
          });

          this.calculate_total();
        }, 300); // ⏱ 300ms is ideal
      },
    },
    relatedDetail: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param && param.id && param.id > 0) {
          this.get_line_items(param);
        }
      },
    },

    contractYears() {
      if (this.selected_line_items && this.selected_line_items.length > 0) {
        this.selected_line_items.forEach((item) => {
          this.$set(item, "yearly_costs", []);
        });

        this.$nextTick(() => {
          this.emit_values();
        });
      }
    },

    itemSet: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.selected_line_items = this.vSelectedLineItem;
          this.selected_line_items.map((row, index) => {
            this.selected_line_items[index].discount_type =
              this.lodash.toSafeInteger(row.discount_type);
            this.selected_line_items[index].cimages = row.item_images;
          });
          (this.show_price = param.show_price == 1 ? true : false),
            (this.adjustment = param.adjustment);
          this.gst_value =
            param.tax_value > 0
              ? param.tax_value
              : this.currentEntityDb.gstvalue;
          this.tax_active = param.tax_applied == 1 ? true : false;
          this.discount_level =
            param.discount_type == 1 ? "transaction" : "line_item";
          if (param && param.discount_value_type) {
            this.discount_value = param.discount_value;
            this.discount_type = this.lodash.toSafeInteger(
              param.discount_value_type
            );
          }
          this.calculate_total();
        }
      },
    },
    isCollected: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.show_collected = true;
        } else {
          this.show_collected = false;
        }
      },
    },
    /*  warrantyObject: {
          deep: true,
          immediate: true,
          handler(param) {
            console.log(param, "paramparamparam");
        
          },
        }, */
  },
  methods: {
    validateSellingCostInput(event) {
      if (
        event.ctrlKey ||
        event.metaKey ||
        [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "Home",
          "End",
          "Tab",
          "Enter",
          "Escape",
          "Shift",
        ].includes(event.key)
      ) {
        return;
      }

      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const nextValue = value.slice(0, start) + event.key + value.slice(end);

      if (
        event.key.length !== 1 ||
        !/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)
      ) {
        event.preventDefault();
      }
    },
    validateSellingCostPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue = value.slice(0, start) + pastedValue + value.slice(end);

      if (!/^\d{0,6}(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
      }
    },
    validateTransactionDiscountPaste(event) {
      const input = event.target;
      const value = input.value || "";
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const pastedValue = event.clipboardData.getData("text");
      const nextValue =
        value.substring(0, start) + pastedValue + value.substring(end);

      if (!/^\d*(?:\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
        return;
      }

      const discountValue = Number(nextValue);
      const exceedsLimit =
        (this.discount_type == 1 && discountValue > Number(this.subtotal)) ||
        (this.discount_type == 2 && discountValue > 100);

      if (exceedsLimit) {
        event.preventDefault();
      }
    },
    validateDiscountKeypress(event, row) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];
      if (allowedKeys.includes(event.key)) return;

      const currentValue = event.target.value || "";
      const nextValue = Number(currentValue + event.key);

      // % discount → max 100 ONLY
      if (row.discount_type == 2) {
        if (nextValue > 100) {
          event.preventDefault();
        }
        return;
      }

      // flat discount → max rate
      const rate = Number(row.rate || 0);
      if (nextValue > rate) {
        event.preventDefault();
      }
    },
    changeDiscountType2(row) {
      if (row.discount_type == 2) {
        if (Number(row.discount_value) > 100) {
          row.discount_value = 100;
        }
      }

      // Flat discount
      if (row.discount_type == 1) {
        row.discount_value = 0;
      }

      this.calculate_total();
    },
    manageDiscount($event) {
      const e = $event;
      const input = e.target;
      const key = e.key || String.fromCharCode(e.which || e.keyCode);
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          event.key
        )
      ) {
        return;
      }
      const newValue =
        input.value.substring(0, input.selectionStart) +
        key +
        input.value.substring(input.selectionEnd);
      if (isNaN(newValue)) {
        e.preventDefault();
        return;
      }
      if (
        (Number(newValue) > Number(this.subtotal) && this.discount_type == 1) ||
        (Number(newValue) > 100 && this.discount_type == 2)
      ) {
        e.preventDefault();
        return;
      }
    },
    changeDiscountType() {
      if (this.discount_type == 2 && this.discount_value > 100) {
        this.discount_value = 100;
      }
      if (this.discount_type == 1) {
        this.discount_value = 0;
      }
      this.calculate_total();
    },
    UomData() {
      this.manageUnitDialog = true;
      this.getOptions();
    },
    getOptions() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "setting/get-all-unit",
        })
        .then((response) => {
          _this.unitList = response.data;
          _this.$emit("close-dialog", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    formatKey(key) {
      const match = key.match(/^([a-zA-Z]+)(\d+)$/);
      if (match) {
        const [, letters, numbers] = match;
        return `${this.capitalize(letters)} ${numbers}`;
      }
      return this.capitalize(key);
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    closeDialog() {
      this.selectedLineItem.yearly_costs = JSON.parse(
        JSON.stringify(this.defaultYearlyCosts)
      );
      this.yearCostDialog = false;
    },
    openYearCostDialog(row) {
      if (!row.yearly_costs) {
        this.$set(row, "yearly_costs", []);
      }

      this.defaultYearlyCosts = JSON.parse(JSON.stringify(row.yearly_costs));

      const years = this.contractYears;

      const costsMap = new Map(
        row.yearly_costs.map((item) => [item.year, item])
      );

      const updatedCosts = [];

      for (let i = 1; i <= years; i++) {
        if (costsMap.has(i)) {
          updatedCosts.push(costsMap.get(i));
        } else {
          updatedCosts.push({ year: i, cost: null });
        }
      }

      this.$set(row, "yearly_costs", updatedCosts);
      this.selectedLineItem = row;
      this.yearCostDialog = true;
    },

    getOrdinalSuffix(n) {
      const lastDigit = n % 10;
      const lastTwoDigits = n % 100;

      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return n + "th";
      }

      switch (lastDigit) {
        case 1:
          return n + "st";
        case 2:
          return n + "nd";
        case 3:
          return n + "rd";
        default:
          return n + "th";
      }
    },

    savedata(data) {
      this.selected_line_items[data.index].serialNumber = data.data;
      /*    this.localEntity = data.data; */
      this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
      this.seleceDialog = false;
    },
    optionSerial(row, index) {
      this.transactionDetail = row;
      this.numbersArr = row?.serial_numbers_input;
      this.numberIndex = index;
      this.seleceDialog = true;
    },
    checkAvailableQuantity(row) {
      if (Number(row.quantity) > 5000) {
        ErrorEventBus.$emit("update:error", "Quantity cannot exceed 5000");
        row.quantity = 5000;
        return;
      }
    },
    selectImage(index) {
      this.customIndex = index;
      this.$refs[`line-item-image`].$refs["input"].click();
    },
    async updateProfileImage(param) {
      if (param && param.length) {
        const promises = [];
        for (let i = 0; i < param.length; i++) {
          const image = await this.convertImageToBase64(param[i]);
          promises.push(image);
        }
        const lineItems = this.lodash.cloneDeep(this.selected_line_items);
        const _cimage = lineItems[this.customIndex].cimages
          ? lineItems[this.customIndex].cimages
          : [];
        lineItems[this.customIndex].cimages = [..._cimage, ...promises];
        this.selected_line_items = lineItems;
        this.$nextTick(() => {
          this.emit_values();
        });
        this.$refs[`line-item-image`].$refs["input"].value = null;
        this.imageSrc = [];
      }
    },
    convertImageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imageSrc.push(reader.result);
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },
    removeImage(index, pIndex) {
      this.selected_line_items[pIndex].cimages.splice(index, 1);
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    auto_adjust() {
      let total = toBtxNumber(this.total);
      if (total > 0) {
        let adjustment = toBtxFixed(total / 10) * 10 - total;
        this.adjustment = toBtxFixed(adjustment);
        this.$nextTick(() => {
          this.calculate_total();
        });
      }
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "equipment") {
        routeName = "client-equipment.detail";
      } else if (data.product_type == "tools") {
        routeName = "equipment.detail";
      } else if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "service") {
        routeName = "service.detail";
      } else if (data.product_type == "parts") {
        routeName = "part.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.replace(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    get_col_style(param, child) {
      let width = 46;
      if (param == "product") {
        if (!this.show_price) {
          width = 70;
        } else if (this.show_price) {
          width = 46;
          if (this.discount_level == "transaction") {
            width = 70;
          }
        }
      }
      return { width: child ? `${width - 5}%` : `${width}%` };
    },
    calculate_total() {
      let d_type = this.discount_level;

      this.subtotal = 0;
      this.discount = 0;
      this.gst = 0;
      this.gst_amount = 0;
      this.total_non_text_amount = 0;

      for (let i = 0; i < this.selected_line_items.length; i++) {
        let total = this.accountingToFixed(
          toBtxNumber(this.selected_line_items[i].quantity) *
            toBtxNumber(this.selected_line_items[i].rate)
        );
        let discount = 0;

        if (d_type == "line_item") {
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 1
          ) {
            discount = toBtxNumber(this.selected_line_items[i].discount_value);
          }
          if (
            this.lodash.toSafeInteger(
              this.selected_line_items[i].discount_type
            ) == 2
          ) {
            discount = this.accountingToFixed(
              (toBtxNumber(total) *
                toBtxNumber(this.selected_line_items[i].discount_value)) /
                100
            );
          }
        }
        this.selected_line_items[i].total =
          isNaN(total) || !total
            ? 0
            : toBtxNumber(total) - toBtxNumber(discount);
        this.subtotal = this.accountingToFixed(
          toBtxNumber(this.subtotal) +
            toBtxNumber(this.selected_line_items[i].total)
        );
      }

      let subtotal = this.subtotal;

      if (d_type == "transaction") {
        this.discount = 0;
        if (this.discount_type == 1) {
          this.discount = toBtxNumber(this.discount_value);
          if (this.discount > subtotal) {
            this.discount_value = 0;
            this.discount = 0;
          }
        }
        if (this.discount_type == 2) {
          this.discount = this.accountingToFixed(
            (toBtxNumber(subtotal) * toBtxNumber(this.discount_value)) / 100
          );
        }
      }

      subtotal = toBtxNumber(subtotal) - toBtxNumber(this.discount);

      this.total_non_text_amount = subtotal;
      if (this.tax_active) {
        this.gst_amount = subtotal;
        this.gst = this.accountingToFixed(
          (toBtxNumber(subtotal) * toBtxNumber(this.gst_value)) / 100
        );
      }

      subtotal = toBtxNumber(subtotal) + toBtxNumber(this.gst);

      this.total = this.accountingToFixed(
        toBtxNumber(subtotal) + toBtxNumber(this.adjustment)
      );

      this.collectedAmountEmit();
      this.emit_values();
      if (this.relatedType == 3) {
        this.generateInvoiceSchedule();
      }
      if (this.relatedType == 1 && !this.isEdit) {
        this.generateInvoiceScheduleQuote();
        /* this.$store.commit(UPDATE_SCHEDULE_STATE, {
          key: "isEdit",
          value: false,
        }); */
      }
    },
    collectedAmountEmit() {
      this.collected_amount = this.total;
    },
    closeProductDialog() {
      this.product_dialog = false;
      this.module_type = null;
    },
    update_line_item(param) {
      if (this.append_child) {
        let child_index = toBtxNumber(this.child_index);
        for (let item of param) {
          item.is_child = true;
          child_index = child_index + 1;
          this.selected_line_items = this.arrayInsert(
            this.selected_line_items,
            child_index,
            item
          );
        }
      } else {
        for (let item of param) {
          this.selected_line_items.push(item);
        }
      }

      this.calculate_total();

      this.$nextTick(() => {
        this.emit_values();
        this.product_dialog = false;
        this.append_child = false;
        this.product_type = null;
        this.child_index = null;
      });
    },
    remove_property(index) {
      this.selected_line_items[index].property = new Object();

      this.$nextTick(() => {
        this.emit_values();
      });
    },
    checkData() {
      if (this.discount_type == 2 && this.discount_value) {
        if (this.discount_value > 100) {
          this.discount_value = 100;
        }
      }
    },
    changeEquipment(index, row) {
      this.selected_line_items[index].is_equipment = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeDes(index, row) {
      this.selected_line_items[index].description = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeName(index, row) {
      this.selected_line_items[index].product = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    OpenchangeWarrnty(index) {
      this.eIndex = index;
      this.addWarrantyDialog = true;
    },
    generateInvoiceSchedule() {
      let invoiceArray = [];
      invoiceArray = this.rawScheduleOutput.map((item) => ({
        daysOfWeek: item?.daysOfWeek,
        startDate: item?.startDate,
        dueDate: this.dueDate(item?.startDate),
        billing_amount: this.total,
        status: 1,
        isEdited: 0,
        isDisabled: 0,
        isPrimary: 0,
        uuid: item?.uuid,
      }));
      this.$store.commit(UPDATE_SCHEDULE_LIST, {
        key: "dbInvoiceVisitScheduleOutput",
        value: invoiceArray,
      });
    },
    dueDate(date) {
      let day = 15;
      if (this.recurringinvoice?.payment_due == 2) {
        day = 15;
      } else if (this.recurringinvoice?.payment_due == 3) {
        day = 30;
      } else if (this.recurringinvoice?.payment_due == 4) {
        day = 45;
      }
      let dueData = moment(date).add(day, "days").format("YYYY-MM-DD");
      return dueData;
    },
    generateInvoiceScheduleQuote() {
      /*  let invoiceArray = []; */
      let invoiceArrayTotelAmt = [];
      let total = 0;
      if (this.quoteInvoiceParameters?.invoice_amount_type == "total_amount") {
        total = this.total_non_text_amount;
      } else {
        total =
          this.total_non_text_amount /
          Number(this.invoiceRecurringSchedule?.occurrence);
      }
      invoiceArrayTotelAmt = this.invoiceScheduleOutput?.map((item) => ({
        daysOfWeek: item?.daysOfWeek,
        startDate: item?.startDate,
        dueDate: this.dueDateQue(item?.startDate),
        billing_amount: total,
        status: 1,
        isEdited: 0,
        isDisabled: 0,
        isPrimary: 0,
        otherItem: item?.otherItem ?? [],
        toatalAmt: item?.toatalAmt ?? 0,
      }));
      this.$store.commit(UPDATE_SCHEDULE_LIST_QUOTE, {
        key: "dbScheduleOutput",
        value: invoiceArrayTotelAmt,
      });
    },
    dueDateQue(date) {
      let day = 15;
      if (this.quoteInvoiceParameters?.payment_due == 2) {
        day = 15;
      } else if (this.quoteInvoiceParameters?.payment_due == 3) {
        day = 30;
      } else if (this.quoteInvoiceParameters?.payment_due == 4) {
        day = 45;
      }
      let dueData = moment(date).add(day, "days").format("YYYY-MM-DD");
      return dueData;
    },
    warrantyData(data) {
      this.selected_line_items[this.eIndex].equipment_warranty = 0;
      this.selected_line_items[this.eIndex].warranty_cost = data.cost;
      this.selected_line_items[this.eIndex].warranty_description =
        data.description;
      this.selected_line_items[this.eIndex].warranty_duration = data.duration;
      this.selected_line_items[this.eIndex].warranty_duration_type =
        data.duration_type;
      this.selected_line_items[this.eIndex].warranty_end_date = data.end_date;
      this.selected_line_items[this.eIndex].warranty_start_date =
        data.start_date;
      this.selected_line_items[this.eIndex].warranty_unique_id = data.unique_id;
      this.selected_line_items[this.eIndex].warranty_type = data.warranty_type;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    changeWarrnty(index, row) {
      this.selected_line_items[index].equipment_warranty =
        row.equipment_warranty;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    update_child_property(row) {
      this.selected_line_items[this.child_index].property = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },
    add_child(index, type) {
      this.append_child = true;
      this.dialog_key = Number(new Date());
      this.child_index = index;
      if (type == "property" || type == "equipment" || type == "tools") {
        if (!this.vCustomerId && !type == "tools") {
          this.scrollToTop();
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "equipment") {
          this.product_type = type;
          this.product_dialog = true;
        } else if (type == "tools") {
          this.product_type = type;
          this.product_dialog = true;

          /*     this.property_dialog = true; */
        } else {
          this.property_dialog = true;
        }
      }
      if (type == "product" || type == "parts") {
        this.product_type = type;
        this.product_dialog = true;
      }

      if (type == "service") {
        this.product_type = type;
        this.product_dialog = true;
      }
    },
    emit_values() {
      this.$nextTick(() => {
        this.$store.dispatch(SET_VISIT_CALCULATION, {
          discount_type: this.lodash.toSafeInteger(this.discount_type),
          discount_value: this.discount_value,
          tax_active: this.tax_active,
          adjustment: this.adjustment,
          collected_amount: this.collected_amount,
          visit_amount: this.total,
          show_price: this.show_price,
          discount_level: this.discount_level,
          calculate_total: this.calculate_total,
          tax_value: this.gst_value,
          total_non_text_amount: this.total_non_text_amount,
        });
        this.$store.dispatch(SET_VISIT_LINE_ITEM, this.selected_line_items);
      });
    },

    open_dialog(param) {
      if (!param) {
        return false;
      }
      if (param == "equipment") {
        if (!this.vCustomerId && !this.$route.query.customer) {
          this.scrollToTop();
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
      }
      this.dialog_key = Number(new Date());
      this.product_type = param;
      this.product_dialog = true;
    },
    add_header() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: 0,
        order: len,
        type: "header",
        product_type: "header",
        is_child: false,
        has_child: false,
        has_property: false,
        product: null,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    add_other() {
      let len = this.selected_line_items.length + 1;
      this.selected_line_items.push({
        status: true,
        index: uuidv4(),
        uuid: uuidv4(),
        id: null,
        image: {},
        order: len,
        serial_no: null,
        eq_model: null,
        location: null,
        group: null,
        discount: 0,
        type: "other",
        is_child: false,
        parent_uuid: null,
        has_child: true,
        has_property: true,
        property: {},
        group_primary: false,
        discount_value: 0,
        discount_type: 1,
        to_equipment: 0,
        product: null,
        project_price: 0,
        threshold_price: 0,
        product_id: 0,
        product_type: "other",
        description: null,
        has_warranty: false,
        warranty: {},
        rate: 0,
        selling_cost: 0,
        quantity: 1,
        uom: null,
        total: 0,
      });
      this.$nextTick(() => {
        this.product_type = null;
        this.emit_values();
      });
    },
    get_line_items(param) {
      let id = param.id;
      this.loading = true;
      this.$store
        .dispatch(QUERY, {
          url: `visit-v1/${id}/line-items`,
          data: {
            type: this.relatedType,
          },
        })
        .then(({ data }) => {
          this.selected_line_items = data;

          this.selected_line_items.map((row, index) => {
            this.selected_line_items[index].discount_type =
              this.lodash.toSafeInteger(row.discount_type);
            this.selected_line_items[index].cimages = row.item_images;
          });
          (this.show_price = param.show_price == 1 ? true : false),
            (this.adjustment = param.adjustment);
          this.collected_amount = param.collected_amount;
          this.gst_value =
            param.tax_value > 0
              ? param.tax_value
              : this.currentEntityDb.gstvalue;
          this.tax_active = param.tax_applied == 1 ? true : false;
          this.discount_level =
            param.discount_type == 1 ? "transaction" : "line_item";
          if (param && param.discount_value_type) {
            this.discount_value = param.discount_value;
            this.discount_type = this.lodash.toSafeInteger(
              param.discount_value_type
            );
          }
          this.calculate_total();
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    remove_row(index, row) {
      if (row.preventive_id > 0 && row.id > 0 && row?.is_consumed > 0) {
        this.$emit("remove:payload", row);
      }

      this.selected_line_items.splice(index, 1);
      this.calculate_total();
      this.emit_values();
      if (this.relatedType == 3) {
        this.generateInvoiceSchedule();
      }
    },
    isGSTAllowed() {
      const app_config = AppConfiguration.get();
      const { entity } = app_config;
      const currentEntity = find(entity, { id: this.entityId });
      this.currentEntityDb = currentEntity;
      this.gst_value = currentEntity.gstvalue > 0 ? currentEntity.gstvalue : 9;

      if (currentEntity) {
        if (currentEntity.gst) {
          if (
            this.isJob ||
            this.isEnquiry ||
            this.isQuotation ||
            this.isPreventive
          ) {
            this.tax_active = true;
            return true;
          } else {
            this.tax_active = false;
          }
        }
      }
      return true;
    },
    openSchedule(id) {
      this.pmId = id;
      this.scheduleDialog = true;
    },

    saveCost() {
      const invalidCosts = Object.values(
        this.selectedLineItem.yearly_costs
      ).filter(
        (year) =>
          year.cost == null || year.cost === "" || isNaN(Number(year.cost))
      );

      if (invalidCosts.length > 0) {
        ErrorEventBus.$emit(
          "update:error",
          `Cost is missing for ${invalidCosts.length} year${
            invalidCosts.length > 1 ? "s" : ""
          }`
        );
        return;
      }

      this.$nextTick(() => {
        this.emit_values();
      });
      this.yearCostDialog = false;
    },
  },
  components: {
    Draggable,
    LineItemDialog,
    AddressSelect,
    ManageWarranty,
    PMSchedule,
    SerialNumber,
    Dialog,
    ManageUnit,
  },
  mounted() {
    this.do_update = this.lodash.toSafeInteger(this.$route.query.do_update);
    this.previousContractYear = parseInt(this.contractYears) || 0;
    this.isGSTAllowed();
    this.getOptions();
  },
  beforeMount() {
    this.pmData = this.$route?.query?.pmSchedule;
  },
  created() {
    const relatedId = Number(this.$route?.query?.edit ?? 0);
    if (relatedId > 0) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, {
        key: "isEdit",
        value: true,
      });
      this.$store.commit(UPDATE_SCHEDULE_LIST_QUOTE, {
        key: "dbScheduleOutput",
        value: this.dbInvoiceUpdateSchedule,
      });
    }
  },
  computed: {
    ...mapGetters([
      "vCustomerId",
      "vStateLoading",
      "vLineItem",
      "vSelectedLineItem",
      "vLineItemAlpha",
      "vLineItemCategory",
      "rawScheduleOutput",
      "recurringinvoice",
      "invoiceScheduleOutput",
      "invoiceRecurringSchedule",
      "quoteInvoiceParameters",
      "dbInvoiceUpdateSchedule",
      "isEdit",
    ]),

    contractYearsArray() {
      return Array.from({ length: this.contractYears }, (_, i) => ({
        year: i + 1,
        cost: "",
      }));
    },

    barCode() {
      const barcode = this.selectedLineItem?.barcode;
      return barcode ? barcode.replace(/\s*-\s*/g, "") : null;
    },
    filledCostCount() {
      if (!this.selectedLineItem || !this.selectedLineItem.yearly_costs)
        return 0;
      return Object.values(this.selectedLineItem.yearly_costs).filter(
        (entry) => {
          const cost = entry.cost;
          return cost !== null && cost !== "" && !isNaN(cost);
        }
      ).length;
    },
  },
};
</script>
